import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ModulesContext = createContext({ modules: { rehearsal_reports: true, budget: true, script: true }, refresh: () => {} });

export function ModulesProvider({ children }) {
  const [modules, setModules] = useState({ rehearsal_reports: true, budget: true, script: true });
  const { user } = useAuth();

  const refresh = async () => {
    try {
      const { data } = await api.get("/modules");
      setModules(data);
    } catch { /* keep defaults */ }
  };

  useEffect(() => { if (user) refresh(); }, [user]);

  return <ModulesContext.Provider value={{ modules, refresh }}>{children}</ModulesContext.Provider>;
}

export const useModules = () => useContext(ModulesContext);
